import React from 'react'
import youtube from '../assets/images/youtube-logo-2431.svg'
import insta from '../assets/images/follow-insta.jpg'
import tg from '../assets/images/follow-tg.png'

export default function TgLink() {
  return (
    <div className='TgLink'>
      <div className="container">
        <div className="row">
            {/* <div className="col-md-4 mb-2">
              <a target='_blank' href="https://www.youtube.com/@ArzonMebellar_01 ">
                <div className='socials-card'>
                  <img className='youtube' src={youtube} alt="socials" />
                  <h3>Подписывайте на наш  <br /><b>YOU TUBE</b>

                  </h3>
                </div>
              </a>
            </div> */}

            <div className="col-md-4 mb-2">
              <a target='_blank' href="https://t.me/dakomebel">
                <img className='socials' src={tg} alt="socials" />
              </a>
            </div>
            <div className="col-md-4 mb-2">
              <a target='_blank' href="https://www.instagram.com/dako.uz?utm_source=qr&stkn=MWh0ZWV0NncwNmJheg%3D%3D">
                <img className='socials' src={insta} alt="socials" />
              </a>  
            </div>
        </div>
      </div>
    </div>
  )
}
